import type { PlatformProviderModelDefinition } from '../../types.js';

export function bulkDeployBuckets(
  definitions: PlatformProviderModelDefinition[],
  tenantId: string
): { deployable: string[]; alreadyActive: string[]; blocked: string[] } {
  const target = tenantId.trim();
  const buckets = {
    deployable: [] as string[],
    alreadyActive: [] as string[],
    blocked: [] as string[],
  };

  for (const definition of definitions) {
    const deployments = definition.deployments ?? [];
    if (
      deployments.some(
        (deployment) => deployment.tenantId === target && deployment.status === 'active'
      )
    ) {
      buckets.alreadyActive.push(definition.modelKey);
    } else if (deployments.some((deployment) => deployment.status === 'active')) {
      buckets.deployable.push(definition.modelKey);
    } else {
      buckets.blocked.push(definition.modelKey);
    }
  }

  return buckets;
}
